import React from 'react';
import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <section id="hero" className="relative pt-24 pb-16 md:pt-32 md:pb-24 bg-primary">
      <div className="absolute inset-0 bg-gradient-to-r from-primary to-primary-dark opacity-80"></div>
      
      {/* Decorative Elements */}
      <div className="absolute right-0 top-1/4 w-32 h-32 rounded-full bg-accent opacity-20 blur-2xl"></div>
      <div className="absolute left-20 bottom-1/4 w-40 h-40 rounded-full bg-secondary opacity-20 blur-3xl"></div>
      
      <div className="container-custom relative z-10 text-center md:text-left flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="md:w-1/2">
          <h1 className="text-white mb-4">
            Turn your online visibility 
            <span className="text-accent block"> up to 11</span>
          </h1>
          <p className="text-light-dark text-lg md:text-xl mb-8 max-w-xl">
            Amplify your search engine rankings with Amplified SEO. We are a small independent SEO agency based in Kent, 
            with over 15 years of experience and a proven track record of successful SEO strategies.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Link 
              to="services" 
              smooth={true} 
              duration={500} 
              className="btn btn-accent"
            >
              Our Services
            </Link>
            <Link 
              to="contact" 
              smooth={true} 
              duration={500} 
              className="btn bg-white text-primary hover:bg-light-dark"
            >
              Contact Us
            </Link>
          </div>
        </div>
        
        <div className="md:w-1/2 relative">
          <div className="w-full h-full rounded-lg overflow-hidden relative shadow-custom transform hover:scale-[1.02] transition-transform">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary to-transparent opacity-30 z-10"></div>
            <div className="bg-accent/10 p-8 md:p-12 rounded-lg border border-white/10">
              <div className="text-8xl text-white/50 leading-none font-display mb-4">11</div>
              <h3 className="text-white mb-4">SEO that Amplifies Results</h3>
              <ul className="text-white space-y-3">
                <li className="flex items-center">
                  <CheckIcon />
                  <span>Affordable packages starting at £300/month</span>
                </li>
                <li className="flex items-center">
                  <CheckIcon />
                  <span>Over 15 years of SEO experience</span>
                </li>
                <li className="flex items-center">
                  <CheckIcon />
                  <span>Specializing in small business & e-commerce</span>
                </li>
                <li className="flex items-center">
                  <CheckIcon />
                  <span>Transparent reporting & proven results</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CheckIcon = () => (
  <svg className="w-5 h-5 mr-2 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
  </svg>
);

export default Hero;
